export default __webpack_public_path__ + "static/media/project-wizard-tracks.3ab0ce9f.png";